export default "__VITE_ASSET__B5Q6IXQo__"